import { apiClient } from '@/core/api/client';
import { PlanningResponse, StatsResponse } from '../types/planning.types';

export const planningAPI = {
  // Get planning data for the expert
  getPlanning: async (): Promise<PlanningResponse> => {
    return apiClient.get('/api/expert/planning');
  },

  // Get expert statistics
  getStats: async (): Promise<StatsResponse> => {
    return apiClient.get('/api/expert/stats');
  },

  // Update appointment
  updateAppointment: async (expertiseId: string, data: any) => {
    return apiClient.patch(`/api/expert/expertise/${expertiseId}/appointment`, data);
  },

  // Get expertise detail
  getExpertiseDetail: async (expertiseId: string) => {
    return apiClient.get(`/api/expert/expertise/${expertiseId}`);
  }
};